// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c5e44ae7d6e06ba5","4823":"d4cdc5a9d776debf","4989":"4f9c6a0808eba73f"}[chunkId] + ".css";
};